import { extendedSearchFields } from '../config';
import generateAdvancedSearchString from './generateAdvancedSearchString';
import type { IExtendedSearch } from '..';
import type { TESSearchFieldNames } from '../definitions';
import { isPartialDate } from 'neuro-utils';

export const makeFinalSearchStringArray = (
  platform: IExtendedSearch['platform'],
  searchFields: IExtendedSearch['searchFields'],
  logicalOperators: IExtendedSearch['logicalOperators'],
) => {
  const searchQueryString = [];

  // gender
  if (searchFields.gender && searchFields.gender !== 'noCropping') {
    searchQueryString.push(`gender=${searchFields.gender}`);
  }

  // includeDeceased --> excludeDeceased
  if (!['yes', 'yesOnlyDeceased'].includes(searchFields.includeDeceased)) {
    searchQueryString.push('excludeDeceased=true');
  }

  if (['yes', 'yesOnlyDeceased'].includes(searchFields.includeDeceased)) {
    // includeDeceased --> onlyDeceased
    if (searchFields.includeDeceased === 'yesOnlyDeceased') {
      searchQueryString.push('onlyDeceased=true');
    }
    // deathDate
    if (searchFields.deathDate && searchFields.deathDate !== 'noCropping') {
      if (isPartialDate(searchFields.deathDate.minDeathDate)) {
        const d = searchFields.deathDate.minDeathDate;
        const year = d[0];
        const month = String(d[1] ?? 1).padStart(2, '0');
        const day = String(d[2] ?? 1).padStart(2, '0');
        searchQueryString.push(`minDeceasedDate=${year}-${month}-${day}`);
      }
      if (isPartialDate(searchFields.deathDate.maxDeathDate)) {
        const d = searchFields.deathDate.maxDeathDate;
        const year = d[0];
        const resolvedMonth = d[1] ?? 12;
        const month = String(resolvedMonth).padStart(2, '0');
        const day = String(d[2] ?? new Date(year, resolvedMonth, 0).getDate()).padStart(2, '0');
        searchQueryString.push(`maxDeceasedDate=${year}-${month}-${day}`);
      }
    }
  }

  // age
  if (searchFields.age && searchFields.age !== 'noCropping') {
    if (searchFields.age.minAge) searchQueryString.push('minAge=' + searchFields.age.minAge);
    if (searchFields.age.maxAge) searchQueryString.push('maxAge=' + searchFields.age.maxAge);
  }

  searchQueryString.push(
    'search=' +
      encodeURIComponent(
        generateAdvancedSearchString(
          [
            'platform',
            ...(extendedSearchFields()[platform || ''] || []).map(field => field.name as TESSearchFieldNames),
          ],
          {
            platform: platform,
            logicalOperators: logicalOperators,
            ...searchFields,
          },
        ) ?? '',
      ),
  );

  return searchQueryString;
};
